export const searchForInstitution = routingNumber => {
    return {
        type: 'SEARCH_FOR_INSTITUTION',
        routingNumber
    }
}

export const clearAchInstitution = () => {
    return {
        type: 'CLEAR_ACH_INSTITUTION'
    }
}


// WEBPACK FOOTER //
// ./src/actions/achInstitution.actions.js